import { getVideoElementByURL } from '$/utils';
import { FileTypeEnum, getVideoCoverUrl } from '$/utils/upload';
import { isVideoUrl } from '@/utils';
import { normalizeVideoDuration, type VideoDurationInfo } from './mediaCheckAfterUpload';

export type OpenMediaType = 'image' | 'video';

export function getOpenMediaType(url: string): OpenMediaType {
  return isVideoUrl(url) ? 'video' : 'image';
}

/**
 * 从外部 URL 尝试读取视频时长；跨域失败时不阻塞导入流程。
 */
export async function getOpenVideoDuration(url: string) {
  return (await getOpenVideoDurationInfo(url)).duration;
}

/**
 * 从外部 URL 尝试读取视频时长，同时保留展示口径和接口参数口径。
 */
export async function getOpenVideoDurationInfo(url: string): Promise<VideoDurationInfo> {
  if (getOpenMediaType(url) !== 'video') return {};
  try {
    const video = await getVideoElementByURL(url);
    return {
      duration: normalizeVideoDuration(video.duration),
      requestDuration: video.duration,
    };
  } catch (error) {
    console.warn('读取外部视频时长失败:', error);
    return {};
  }
}

/**
 * 创建从 URL 打开的素材项，视频项会尽量补充展示时长和接口参数时长。
 */
export async function createOpenMediaBatchItem(url: string) {
  const mediaType = getOpenMediaType(url);
  const durationInfo = await getOpenVideoDurationInfo(url);
  return {
    id: `open-${Date.now()}`,
    status: 'normal' as const,
    url,
    type: mediaType === 'video' ? FileTypeEnum.Video : FileTypeEnum.Image,
    coverUrl: mediaType === 'video' ? getVideoCoverUrl(url) : '',
    duration: durationInfo.duration,
    requestDuration: durationInfo.requestDuration,
    selected: false,
  };
}
